import cssModule from "./index.module.scss"

export function Counter({ count }) {
	return <div className={cssModule.counter}>{count}</div>
}
